import React, { useEffect, useRef, useState } from "react";
import { Menu, MenuItem, Sidebar, SubMenu } from "react-pro-sidebar";
import { svgCustom } from "../../../util/svgcustom";
import "./sideMenu.scss";
import { useNavigate } from "react-router-dom";
import IoTLogo from "../../../../assets/images/logo/kawal.id.png";
import HamburgerMenu from "../hamburgerMenu";
import storeMenu from "../../../../stores";
import * as CryptoJS from "crypto-js";
import { encryptCode } from "../../../../services/functions";

const SideMenu = () => {
  const navigate = useNavigate();
  const wrapperRef = useRef(null);

  const [role, setRole] = useState("");

  // Set flags berdasarkan role
  const isSuperAdmin = role.toLowerCase() === "superadmin";
  const isAdmin = role.toLowerCase() === "admin";
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const isUser = role.toLowerCase() === "user";
  const canAccessPosition = isSuperAdmin || isAdmin;

  useEffect(() => {
    const encryptedRole = localStorage.getItem("IOT_ROLE") || "";
    if (encryptedRole) {
      try {
        const bytes = CryptoJS.AES.decrypt(encryptedRole, encryptCode);
        const decryptedRole = bytes.toString(CryptoJS.enc.Utf8);
        setRole(decryptedRole);
      } catch (error) {
        console.error("Decrypt role error:", error);
        setRole("");
      }
    }
  }, []);

  console.log("Role state in SideMenu:", role);
  console.log("IsSuperAdmin:", role.trim().toLowerCase() === "superadmin");

  const handleClickOutside = (event: MouseEvent) => {
    if (window.innerWidth < 768) {
      if (
        wrapperRef.current &&
        !(wrapperRef.current as HTMLElement).contains(event.target as Node)
      ) {
        storeMenu.dispatch({ type: "menu", text: false });
        localStorage.removeItem("MENU_STATUS");
        localStorage.setItem("MENU_STATUS", "false");
      }
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    const menuStatus = localStorage.getItem("MENU_STATUS");
    storeMenu.dispatch({ type: "menu", text: menuStatus === "true" });

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleClickSubMenu = (e: React.MouseEvent, path: string) => {
    const buttons = document.querySelectorAll(
      ".ps-menuitem-root:not(.sidemenu-submenu) a.ps-menu-button",
    );
    buttons.forEach((btn) => btn.classList.remove("active"));

    const current = e.currentTarget as HTMLElement;
    current.classList.add("active");

    navigate(path);
  };

  return (
    <div className="side-left-sub" ref={wrapperRef}>
      <Sidebar
        className="sidebarClasses"
        backgroundColor="rgb(249,249,249,0.5)"
        collapsed={false}
      >
        <Menu
          menuItemStyles={{
            button: ({ level, active, disabled }) => ({
              ...(level === 0
                ? {
                    backgroundColor: active ? "#eecef9" : undefined,
                    fontWeight: 500,
                    paddingLeft: "25px",
                    "&": {
                      backgroundColor: "rgba(200, 221, 221, 0.7)",
                    },
                    "&:hover": {
                      backgroundColor: "rgb(197, 228, 255)",
                      color: "rgb(68, 89, 110)",
                      borderRadius: "0",
                    },
                    "&.active": {
                      color: "#b6c8d9",
                    },
                    "&.ps-open": {
                      fontFamily: "Titillium_Web_Bold",
                    },
                    fontFamily: "Titillium_Web_Regular",
                    fontSize: "14px",
                  }
                : {
                    "&": {
                      backgroundColor: "rgba(200, 221, 221, 0.7)",
                      paddingLeft: "50px",
                      fontSize: "14px",
                    },
                    "&:hover": {
                      backgroundColor: "rgb(197, 228, 255)",
                      color: "rgb(68, 89, 110)",
                      borderRadius: "0",
                    },
                    "&.active": {
                      fontWeight: "700",
                    },
                  }),
            }),
          }}
        >
          <div className="logo-header">
            <div className="logo-title-image">
              <img src={IoTLogo} alt="" />
              <div className="sidemenu-ham-menu">
                <HamburgerMenu />
              </div>
            </div>
          </div>

          <div className="pre-title-submenu">
            <p>General</p>
          </div>

          <SubMenu
            className="submenu-custom"
            label="Dashboard"
            defaultOpen={window.location.pathname.includes("/dashboard")}
            icon={svgCustom(
              "dashboard",
              "rgb(44, 169, 188)",
              18,
              18,
              "rgb(0, 0, 0)",
            )}
          >
            <MenuItem
              onClick={(e) => handleClickSubMenu(e, "/dashboard/analitik")}
              style={{
                fontWeight: window.location.pathname.includes(
                  "/dashboard/analitik",
                )
                  ? 700
                  : "normal",
              }}
            >
              <span className="sidemenu-label-submenu">Command Center</span>
            </MenuItem>
            <MenuItem
              onClick={(e) => handleClickSubMenu(e, "/dashboard/history")}
              style={{
                fontWeight: window.location.pathname.includes(
                  "/dashboard/history",
                )
                  ? 700
                  : "normal",
              }}
            >
              <span className="sidemenu-label-submenu">History Location</span>
            </MenuItem>
            {canAccessPosition && (
              <MenuItem
                onClick={(e) => handleClickSubMenu(e, "/dashboard/position")}
                style={{
                  fontWeight: window.location.pathname.includes(
                    "/dashboard/position",
                  )
                    ? 700
                    : "normal",
                }}
              >
                <span className="sidemenu-label-submenu">Position</span>
              </MenuItem>
            )}
          </SubMenu>

          {/* Render Settings hanya untuk Superadmin */}
          {isSuperAdmin && (
            <SubMenu
              className="submenu-custom"
              label="Settings"
              defaultOpen={window.location.pathname.includes("/list")}
              icon={svgCustom("repair", undefined, 30, 30, undefined)}
            >
              <MenuItem
                onClick={(e) => handleClickSubMenu(e, "/list/organization")}
                style={{
                  fontWeight: window.location.pathname.includes(
                    "/list/organization",
                  )
                    ? 700
                    : "normal",
                }}
              >
                <span className="sidemenu-label-submenu">Organization</span>
              </MenuItem>

              <MenuItem
                onClick={(e) => handleClickSubMenu(e, "/list/user")}
                style={{
                  fontWeight: window.location.pathname.includes("/list/user")
                    ? 700
                    : "normal",
                }}
              >
                <span className="sidemenu-label-submenu">User</span>
              </MenuItem>

              <MenuItem
                onClick={(e) => handleClickSubMenu(e, "/list/device")}
                style={{
                  fontWeight: window.location.pathname.includes("/list/device")
                    ? 700
                    : "normal",
                }}
              >
                <span className="sidemenu-label-submenu">Device</span>
              </MenuItem>
            </SubMenu>
          )}

          <SubMenu
            className="submenu-custom"
            label="Help Center"
            defaultOpen={window.location.pathname.includes("/support")}
            icon={svgCustom(
              "help",
              "rgb(44, 169, 188)",
              18,
              18,
              "rgb(0, 0, 0)",
            )}
          >
            <MenuItem
              onClick={(e) => handleClickSubMenu(e, "/support/helpdesk")}
              style={{
                fontWeight: window.location.pathname.includes(
                  "/support/helpdesk",
                )
                  ? 700
                  : "normal",
              }}
            >
              <span className="sidemenu-label-submenu">Helpdesk</span>
            </MenuItem>
          </SubMenu>
        </Menu>
      </Sidebar>
      <div className="side-bottom">
        <div className="logo-img-bottom"></div>
      </div>
    </div>
  );
};

export default SideMenu;
